import { render, staticRenderFns } from "./CouponManage.vue?vue&type=template&id=0a1b62b4&scoped=true"
import script from "./CouponManage.vue?vue&type=script&lang=js"
export * from "./CouponManage.vue?vue&type=script&lang=js"
import style0 from "./CouponManage.vue?vue&type=style&index=0&id=0a1b62b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1b62b4",
  null
  
)

export default component.exports